// OHM Quiz Section CSS

$('.close-quiz-questionnaire').click(function() {
  $('#shopify-section-template--18331568963901__ohm_quiz_dN9Gxb').hide();
});

$('#shopify-section-template--18331568963901__custom_liquid_rBUBEp .ohm-trigger-quiz').click(function() {
  $('#shopify-section-template--18331568963901__ohm_quiz_dN9Gxb').show();
});

function updateButtonStates() {
  $('.question-slide').each(function(index) {
    var $prevBtn = $(this).find('.prev-btn');
    var $nextBtn = $(this).find('.next-btn');

    // Disable Previous button if it's the first slide
    if (index === 0) {
      $prevBtn.addClass('disabled').attr('disabled', true);
    } else {
      $prevBtn.removeClass('disabled').removeAttr('disabled');
    }

    // Disable Continue button if it's the last slide
    if (index === $('.question-slide').length - 1) {
      $nextBtn.addClass('disabled').attr('disabled', true);
    } else {
      $nextBtn.removeClass('disabled').removeAttr('disabled');
    }

    // Check if FINDING YOUR CLOSEST MATCH is active
    if ( $('.finding-closest-match').hasClass('active') ) {
      setTimeout(function() {
        $('.finding-closest-match').find('.next-btn').trigger('click');
      }, 3000);
    }
  });
}

updateButtonStates();

$('.next-btn').on('click', function() {
  var $currentSlide = $(this).closest('.question-slide');
  var nextSlideIndex = $currentSlide.index() + 1;

  if ($('.question-slide').eq(nextSlideIndex).length) {
    $currentSlide.removeClass('active').css('transform', 'translateX(-100%)');
    $('.question-slide').eq(nextSlideIndex).addClass('active').css('transform', 'translateX(0)');
  }

  updateButtonStates();
});

$('.prev-btn').on('click', function() {
  var $currentSlide = $(this).closest('.question-slide');
  var prevSlideIndex = $currentSlide.index() - 1;

  if ($('.question-slide').eq(prevSlideIndex).length) {
    $currentSlide.removeClass('active').css('transform', 'translateX(100%)');
    $('.question-slide').eq(prevSlideIndex).addClass('active').css('transform', 'translateX(0)');
  }

  updateButtonStates();
});

$('.ohm-radio-group input[type="radio"]').on('change', function() {
  if ($(this).closest('.questioniare-item').find('input[type="radio"]').is(':checked')) {
    $(this).closest('.questioniare-item').find('.next-btn').removeClass('disabledbtn');
  }
});

// Trigger display quiz section

$('#shopify-section-template--18331568963901__rich_text_pYXBWU .ohm-trigger-quiz').click(function() {
  var $targetElement = $('#shopify-section-template--18331568963901__ohm_quiz_xt3bNT');
  $targetElement.show();
  var topPosition = $targetElement.offset().top - 69;
  var $this = $(this);
});


var tagsToCheck;
var ishiddened = 0;
var ctr_displayed = 0;
var id_container = [];

function getProductsInQuiz(user_selected_tags, retry = false) {
  tagsToCheck = retry ? user_selected_tags.slice(0, -1) : user_selected_tags;
  
  console.log('tagsToCheck: ' + tagsToCheck);

  $('.w-match').each(function() {
    // Get the product's tags, split them into an array, and convert to lowercase
    var productTags = $(this).data('tags').split(',').map(function(tag) {
      return tag.trim().toLowerCase();
    });

    // console.log('productTags: ' + productTags);

    // Check if the product has all the required tags
    var hasAllTags = tagsToCheck.every(function(tag) {
        return productTags.includes(tag);
    });

    if (hasAllTags) {
      if (ctr_displayed < 4) {
        $(this).show();
        if (id_container.indexOf($(this).data('id')) === -1) {
          id_container.push($(this).data('id'));
          ctr_displayed++;
        }
        ishiddened++;
        
        // console.log( $(this).data('id') );
        // console.log( id_container );
      }
    } else { 
      $(this).hide();  
    }
  });

  if (ishiddened == 0) {
    if (tagsToCheck.length != 0) {
      getProductsInQuiz(tagsToCheck, true);
    }
  } else {
    // if result is less than 3 then run again the script to fetch other product
    if (ctr_displayed < 4) {
      getProductsInQuiz(tagsToCheck, true);
    }
    

    setTimeout(function() {
      $('.w-match').each(function() {
        if($(this).is(':hidden')) {
          $(this).remove();
        } 
      });

      // make carousel closest watches
      var owlmenu = $(".found-closest-match .ohm-watch-match-wrapper");
      // owlmenu.trigger('destroy.owl.carousel');
      owlmenu.addClass('owl-carousel owl-theme').owlCarousel({
          dots: false,
          nav: true,
          items: 1,
          margin: 16,
          slideTransition: 'ease-in-out',
          navText: [
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 40 39" fill="none"><path d="M36.3292 19.6831H3.37082M3.37082 19.6831L19.85 36.1623M3.37082 19.6831L19.85 3.20398" stroke="#1E1E1E" stroke-width="5.65" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 39 40" fill="none"><path d="M3.07068 19.8499H36.029M36.029 19.8499L19.5498 3.37073M36.029 19.8499L19.5498 36.3291" stroke="#1E1E1E" stroke-width="5.65" stroke-linecap="round" stroke-linejoin="round"/></svg>'  
          ],
      });
      
    }, 3000);

    
   
  }
}

// Discover watches based on user selection
var ohmselected = [];
$('#ohmdiscover_watch').click(function(e) {
  e.preventDefault();
  e.stopPropagation();

  $('.ohm-questionnaire-padding .questioniare-items').each(function() {
    ohmselected.push($(this).find('.ohm-radio-group input[type="radio"]:checked').val());
  });

  ohmselected = ohmselected.map(function(tag) {
    return tag.toLowerCase();
  });
  
  getProductsInQuiz(ohmselected);
});

$('#shopify-section-template--18331568963901__ohm_styled_carousel_Gqay39 .ohm-styled-carousel-inner').addClass('owl-carousel owl-theme').owlCarousel({
      dots: false,
      items: 1,
      nav: false,
      rewind: true,
      slideTransition: 'ease-in-out',
      smartSpeed: 1000,
      onInitialized: setCounter,
      onChanged: setCounter,
      responsive : {
        0 : {
          stagePadding: 10,
        },
        649 : {
          stagePadding: 50,
        }
      },
  });

$('#shopify-section-template--18331568963901__ohm_styled_carousel_Gqay39 .block-styled-carousel').each(function() {
  
  $(this).find('.bsc-carousel').addClass('owl-carousel owl-theme').owlCarousel({
      autoplay: true,
      autoplayTimeout: 3000,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',

      mouseDrag: false,
      touchDrag: false,
      dots: false,
      items: 1,
      nav: false,
      rewind: true,
      slideTransition: 'ease-in-out',
      smartSpeed: 1000,
      responsive : {
        0 : {
          // stagePadding: 20,
        },
        649 : {
          // stagePadding: 50,
        }
      },
  });
  
});

function setCounter(event)
{
  var currentSlide = event.item.index; // Get the current slide index
  var totalSlides = event.item.count;  // Get the total slide count

  if (currentSlide < 0) {
      currentSlide = totalSlides + currentSlide + 1;
  } else {
      currentSlide = currentSlide + 1; 
  }

  var formattedCurrentSlide = currentSlide.toString().padStart(2, '0');
  var formattedTotalSlides = totalSlides.toString().padStart(2, '0');

  $('.ohm-styled-carousel-counter > span').text(formattedCurrentSlide + ' - ' + formattedTotalSlides);

  // 
  const $carousel = $(event.target);
  if (formattedCurrentSlide == formattedTotalSlides) {
    $carousel.find('.owl-stage').addClass('nopadding-right');
  }
}

$('.ohm-styled-carousel-right').click(function(e) {
  e.preventDefault();
  $('#shopify-section-template--18331568963901__ohm_styled_carousel_Gqay39 .ohm-styled-carousel-inner').trigger('prev.owl.carousel');
});

$('.ohm-styled-carousel-left').click(function(e) {
  e.preventDefault();
  $('#shopify-section-template--18331568963901__ohm_styled_carousel_Gqay39 .ohm-styled-carousel-inner').trigger('next.owl.carousel');
});


function counter(event) {
  if (!event.namespace) {
    return;
  }
  var slides = event.relatedTarget;

  $('.ohm-styled-carousel-left').toggleClass('inactive', slides.current() + 1 >= slides.items().length);
  $('.ohm-styled-carousel-right').toggleClass('inactive', slides.current() + 1 <= 1);
  
  $('.ohm-styled-carousel-counter > span').text(`${(slides.relative(slides.current()) + 1).toString().padStart(2, '0')} - ${slides.items().length.toString().padStart(2, '0')}`);
}


$('#shopify-section-template--18331568963901__ohm_product_lists_z64Hgy .lists-wrapper').addClass('owl-carousel owl-theme').owlCarousel({
    dots: false,
    nav: false,
    margin: 30,
    slideTransition: 'ease-in-out',
    smartSpeed: 1000,
    responsive : {
      0 : {
        items: 1,
        stagePadding: 70,
      },
      650 : {
        items: 3,
      },
      1024: {
        items: 4,
      }
    },
});

$('#shopify-section-template--18331568963901__ohm_product_lists_z64Hgy .page-width .ohm-pl-right-content svg.ohm-pl-right-btn').click(function(e) {
  e.preventDefault();
  $('#shopify-section-template--18331568963901__ohm_product_lists_z64Hgy .lists-wrapper').trigger('prev.owl.carousel');
});

$('#shopify-section-template--18331568963901__ohm_product_lists_z64Hgy .page-width .ohm-pl-right-content svg.ohm-pl-left-btn').click(function(e) {
  e.preventDefault();
  $('#shopify-section-template--18331568963901__ohm_product_lists_z64Hgy .lists-wrapper').trigger('next.owl.carousel');
});



// "FAMOUS makers of time" section
var previousIndex = 0;
var totalItems = 0;

$('.owl-carousel').on('initialized', function(event) {
    // Get the total number of items after initialization
    totalItems = event.item.count;

    // Set the initial total items count in your counter
    const $total = $('.counter .total');
    $total.text(totalItems.toString().padStart(2, '0'));
    
    // Set the first item text
    setFirstItem(event);
});

var xcarousel = $('#shopify-section-template--18331568963901__ohm_carousel_animation_tKgiJz .ohm-carousel-animation-inner');
xcarousel.addClass('owl-carousel owl-theme').owlCarousel({
  stagePadding: 140,
  smartSpeed: 1000,
  nav: false,
  margin: 32,
  dots: false,
  items: 1,
  responsive : {
    0 : {
      items: 1,
      margin: 16,
      stagePadding: 30,
    },
    649 : {
      items: 1,
      margin: 16,
    },
    1024 : {
      items: 2,
    },
  },

  onInitialized: setFirstItem,
  onChanged: setFirstItem,
});

function setFirstItem(event)
{
  var $items = $(event.target).find('.owl-item');
  $items.removeClass('first-active');
  $items.eq(event.item.index).addClass('first-active');

  const currentIndex = event.item.index + 1; // Adjusted index (starts from 1)
  
  const $current = $('.counter .current');

  if (currentIndex < previousIndex) {
      $current.addClass('slideDown').text(currentIndex.toString().padStart(2, '0'));
      setTimeout(() => {
          $current.removeClass('slideDown');
      }, 500);
  } else if (currentIndex > previousIndex) {
      $current.addClass('slideUp').text(currentIndex.toString().padStart(2, '0'));
      setTimeout(() => {
          $current.removeClass('slideUp');
      }, 500);
  }

  // Update the total item count only when it's initialized or changed
  if (totalItems > 0) {
      $('.counter .total').text(totalItems.toString().padStart(2, '0'));
  }
  
  previousIndex = currentIndex;
}

// Reviews Section

// Function to convert YouTube URL to embed format
function convertToEmbedUrl(url) {
    const videoId = url.split('v=')[1] || url.split('/').pop();
    return `https://www.youtube.com/embed/${videoId}`;
}

$('.ohm-reviews-slider-section #tab_videos iframe').each(function () {
  var embedUrl = convertToEmbedUrl( $(this).attr('src') );
  $(this).attr('src', embedUrl + '?si=o8Gogkw_rzzmuE1d&amp;controls=0');
});


$('.ohm-reviews-slider-section #tab_videos .orss-tab-content-inner').addClass('owl-carousel owl-theme').owlCarousel({
  stagePadding:140,
  margin: 32,
  nav: true,
  loop: true,
  dots: false,
  responsive : {
    0 : {
      items: 1,
      margin: 16,
      stagePadding: 20,
    },
    1024 : {
      items: 3,
    },
  },
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 40 39" fill="none"><path d="M36.3292 19.6831H3.37082M3.37082 19.6831L19.85 36.1623M3.37082 19.6831L19.85 3.20398" stroke="#1E1E1E" stroke-width="5.65" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 39 40" fill="none"><path d="M3.07068 19.8499H36.029M36.029 19.8499L19.5498 3.37073M36.029 19.8499L19.5498 36.3291" stroke="#1E1E1E" stroke-width="5.65" stroke-linecap="round" stroke-linejoin="round"/></svg>'  
  ],
});

// $('.ohm-reviews-slider-section #tab_written .orss-tab-content-inner').addClass('owl-carousel owl-theme').owlCarousel({
//   center: true,
//   stagePadding: 80,
//   margin: 32,
//   loop: true,
//   // autoWidth:true,
//   nav: false,
//   dots: false,
//   responsive : {
//     0 : {
//       items: 1,
//       margin: 16,
//       stagePadding: 20,
//       center: false,
//     },
//     649 : {
//       items: 2,
//       margin: 16,
//       center: false,
//     },
//     1024 : {
//       items: 5,
//     },
//   },
// });

// Tab Switching with jQuery
$('.tab-link').on('click', function() {
  var tabId = $(this).data('tab');

  // Remove active classes from all tabs and tab links
  $('.tab-content').removeClass('active');
  $('.tab-link').removeClass('active');

  // Activate the clicked tab and link
  $('#' + tabId).addClass('active');
  $(this).addClass('active');
});


// Define array of selectors
// var arr_elements = [
//   '#shopify-section-template--18331568963901__ohm_product_lists_z64Hgy .owl-stage-outer',
//   '#shopify-section-template--18331568963901__ohm_reviews_slider_BYPzyW .owl-stage-outer'
// ];

// if ($(window).width() <= 1680) {
//   var screenWidth = $(window).width() + 62;
// } else {
//   var screenWidth = $(window).width();
// }

// arr_elements.forEach(function(selector) {
//   $(selector).css("width", screenWidth + "px");
// });

// $(window).resize(function() {
//   if ($(window).width() <= 1680) {
//     screenWidth = $(window).width() + 62;  
//   } else {
//     screenWidth = $(window).width();
//   }
  
//   arr_elements.forEach(function(selector) {
//       $(selector).css("width", screenWidth + "px");
//   });
// });


// Vertical carousel columns

$('.ohm-vertical-carousel-section').each(function() {
    var section = $(this); // Get the current section

    section.find('.ovcs-vertical-inner').addClass('owl-carousel owl-theme').owlCarousel({
        rewind: true,
        smartSpeed: 600,
        nav: false,
        dots: false,
        responsive : {
          0 : {
            center: true,
            items: 1,
            loop: true,
            stagePadding: 40,
          },
          991 : {
            items: 1,
          },
        },
        onChanged: function(event) {
            showCarousel(event, section);
        }
    });

    function showCarousel(event, section) {
        var currentIndex = event.item.index;
        var totalItems = event.item.count;
        var currentItem = $(event.target).find('.owl-item').eq(currentIndex);
        var dataType = currentItem.find('.ohm-rss-text-image-item').data('type');

        section.find('.ovcs-auto-slide .owl-carousel[data-type="'+ dataType +'"]').trigger('destroy.owl.carousel');
        var selector = '.ovcs-auto-slide .owl-carousel[data-type="'+ dataType +'"]';
        reinitOwl(selector);

        section.find('.ovcs-auto-slide .owl-carousel').css('opacity', 0);
        section.find('.ovcs-auto-slide .owl-carousel[data-type="'+ dataType +'"]').css('opacity', 1);

        // Add class to the current, previous, and next items
        var items = $(event.target).find('.owl-item');
        var prevIndex = (currentIndex === 0) ? totalItems - 1 : currentIndex - 1; // Handle wrap around for the previous item
        var nextIndex = (currentIndex === totalItems - 1) ? 0 : currentIndex + 1; // Handle wrap around for the next item
    
        // Remove previous class from all items
        items.removeClass('prev-item next-item');
    
        // Add 'prev-item' and 'next-item' classes
        items.eq(prevIndex).addClass('prev-item');
        items.eq(nextIndex).addClass('next-item');
        
        // Add class for the current item (if needed)
        items.eq(currentIndex).addClass('current-item');
    }
});

$('.ohm-vertical-carousel-section .ovcs-vertical-inner').data('owl.carousel').difference = function(first, second) {
	return {
		x: first.x - second.x + (first.y - second.y),
		y: first.y - second.y
	};
};

$('.ohm-vertical-carousel-section').each(function() {
    var section = $(this);
    var grouped = {};

    section.find('.ovcs-auto-slide .ohm-rss-written-img').each(function() {
        var dataType = $(this).data('type');
        if (!grouped[dataType]) {
            grouped[dataType] = [];
        }
        grouped[dataType].push(this);
    });

    $.each(grouped, function(type, elements) {
        var groupContainer = $('<div class="group-container" data-type="'+ type +'"></div>');
        $.each(elements, function(index, element) {
            groupContainer.append(element);
        });

        section.find('.ovcs-auto-slide').append(groupContainer);

        section.find('.ovcs-auto-slide > .group-container').each(function(index, element) {
            reinitOwl(element);
        });
    });
});

function reinitOwl(selector) {
  $(selector).addClass('owl-carousel owl-theme').owlCarousel({
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    smartSpeed: 600,
    items: 1,
    loop: true,
    nav: false,
    dots: false,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut'
  });

  // $(selector).css("width", ((35 / 100) * screenWidth) + "px");
}

$('.ohm-vertical-carousel-section .ovcs-right-btn').click(function(e) {
  e.preventDefault();
  $(this).closest('.ohm-vertical-carousel-section .ovcs-vertical .owl-carousel').trigger('prev.owl.carousel');
});

$('.ohm-vertical-carousel-section .ovcs-left-btn').click(function(e) {
  e.preventDefault();
  $(this).closest('.ohm-vertical-carousel-section .ovcs-vertical .owl-carousel').trigger('next.owl.carousel');
});









